import api from './apiClient';

/**
 * Event role request API (promoter/staff/sale agent).
 */
export const roleApi = {
  requestRole: (eventId, roleType, message) =>
    api.post(`/events/${eventId}/roles`, { roleType, message }),

  getMyRoles: () => api.get('/event-roles/me'),

  getEvents: (params = {}) => api.get('/events', { params }),

  getAllRoles: (params = {}) => api.get('/event-roles', { params }),

  decide: (roleId, decision, note) =>
    api.post(`/event-roles/${roleId}/decision`, { decision, note }),
};

export default roleApi;
